import BurgerSpanUi from 'common/components/entities/Menu/components/Mobile/Burger/ui/BurgerSpanUi'
import BurgerUi from 'common/components/entities/Menu/components/Mobile/Burger/ui/BurgerUi'
import BurgerWrapperUi from 'common/components/entities/Menu/components/Mobile/Burger/ui/BurgerWrapperUi'
import { AlignSelfType, PaddingType } from 'common/types/styleTypes'
import React from 'react'

type BurgerProps = {
  handleClick?: () => void
  burgerIconColor: string
  opened?: boolean
  openedColor?: string
  forceVisible?: boolean
  fixed?: boolean
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  burgerAlignSelf: AlignSelfType | undefined
}

function Burger({
  handleClick,
  burgerIconColor,
  opened = false,
  openedColor,
  forceVisible = false,
  fixed = false,
  padding,
  mobilePadding,
  burgerAlignSelf = 'flex-end',
}: BurgerProps) {
  return (
    <BurgerWrapperUi
      justifyContent={burgerAlignSelf}
      padding={padding}
      mobilePadding={mobilePadding}
      opened={opened}
      forceVisible={forceVisible}
    >
      <BurgerUi
        onClick={handleClick}
        opened={opened}
        forceVisible={forceVisible}
        fixed={fixed}
      >
        <BurgerSpanUi
          burgerIconColor={burgerIconColor}
          openedColor={openedColor}
          opened={opened}
        />
        <BurgerSpanUi
          burgerIconColor={burgerIconColor}
          openedColor={openedColor}
          opened={opened}
        />
        <BurgerSpanUi
          burgerIconColor={burgerIconColor}
          openedColor={openedColor}
          opened={opened}
        />
      </BurgerUi>
    </BurgerWrapperUi>
  )
}

export default Burger
